<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/mZjS5H/tc-custom/9780226848969.jpg?1722578803755" alt="This image is the cover for the book Poets and Murder, The Judge Dee Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Poets and Murder, The Judge Dee Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <p>Judge Dee, the master detective of seventh-century China, sets out to solve a puzzling double murder and discovers complex passions lurking beneath the placid surface of academic life. A mild-mannered student is rumored to have been slain by a fox-demon, while a young dancer meets her death as she dresses to perform for the magistrate's illustrious dinner guests—an obese Zen monk revered for his calligraphy, a beautiful poetess accused of murder, and the past president of the imperial academy. To connect the present crimes with betrayals and adulteries from decades past, the clever judge must visit a high-class brothel and the haunted shrine of the Black Fox. From the moment the young scholar is found dead on the eve of the Autumn Festival, the pace never lets up.<br/><br/> "The China of old, in Mr. van Gulik's skilled hands, comes vividly alive again."—Allen J. Hubin, <i>New York Times Book Review<br/><br/></i> "If you have not yet discovered Judge Dee, I envy you that initial pleasure. . . . For the magistrate of Poo-yang belongs in that select group headed by Sherlock Holmes."—Robert Kirsch, <i>Los Angeles Times<br/><br/></i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robert van Gulik
      </h2>
      
      <p class="authorDescription body article"><B>Robert van Gulik</B> (1910-67), a Dutch diplomat and an authority on Chinese history and culture, drew his plots and literary conventions from the popular detective novels that appeared in seventeenth-century China.<br></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Chicago Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?07910eb3